import { createAction } from '@reduxjs/toolkit';

import {
    ANALYTICS_PARTNER_HOSTED_ONBOARDING_INELIGIBLE_STATE_MODAL_CLOSE,
    ANALYTICS_PARTNER_HOSTED_ONBOARDING_INELIGIBLE_STATE_MODAL_EDIT_ADDRESS,
    ANALYTICS_PARTNER_HOSTED_ONBOARDING_INELIGIBLE_STATE_MODAL_OPEN,
} from '@perpay-web/fintech/constants/actionTypes';

export const analyticsPartnerHostedOnboardingInEligibleStateModalOpen = () => ({
    type: ANALYTICS_PARTNER_HOSTED_ONBOARDING_INELIGIBLE_STATE_MODAL_OPEN,
});
export const analyticsPartnerHostedOnboardingInEligibleStateModalClose =
    () => ({
        type: ANALYTICS_PARTNER_HOSTED_ONBOARDING_INELIGIBLE_STATE_MODAL_CLOSE,
    });
export const analyticsPartnerHostedOnboardingInEligibleStateModalEditAddress =
    () => ({
        type: ANALYTICS_PARTNER_HOSTED_ONBOARDING_INELIGIBLE_STATE_MODAL_EDIT_ADDRESS,
    });

export const analyticsCKPartnerHostedOnboardingApplicationRejectedClickDashboard =
    createAction(
        'ANALYTICS::CK_PARTNER_HOSTED_ONBOARDING::APPLICATION_REJECTED::CLICK_DASHBOARD',
    );

export const analyticsCKPartnerHostedOnboardingRejectionScreen = createAction(
    'ANALYTICS::PARTNER_HOSTED_ONBOARDING::CK_REJECTION_SCREEN',
);

export const analyticsNonCKPartnerHostedOnboardingApplicationRejectedClickDashboard =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::NON_CK_APPLICATION_REJECTED::CLICK_DASHBOARD',
    );

// CARD MATERIAL SELECTION
export const analyticsPartnerHostedOnboardingSelectMaterialClickHeavyMetal =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::SELECT_MATERIAL::CLICK_HEAVY_METAL',
    );

export const analyticsPartnerHostedOnboardingSelectMaterialClickLightPlastic =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::SELECT_MATERIAL::CLICK_LIGHT_PLASTIC',
    );

export const analyticsPartnerHostedOnboardingApprovalClickAcceptAndContinue =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPROVAL::CLICK_ACCEPT_AND_CONTINUE',
    );

export const analyticsPartnerHostedOnboardingApprovalClickInfoModal =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPROVAL::CLICK_INFO_MODAL',
    );

export const analyticsPartnerHostedOnboardingApprovalClickCloseModal =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPROVAL::CLICK_CLOSE_MODAL',
    );

export const analyticsPartnerHostedOnboardingClickLearnMore = createAction(
    'ANALYTICS::PARTNER_HOSTED_ONBOARDING::PAYMENT_SETUP_SUMMARY::CLICK_LEARN_MORE',
);

export const analyticsPartnerHostedOnboardingViewDDModal = createAction(
    'ANALYTICS::PARTNER_HOSTED_ONBOARDING::PAYMENT_SETUP_SUMMARY::VIEW_DD_MODAL',
);

export const analyticsPartnerHostedOnboardingCloseDDModal = createAction(
    'ANALYTICS::PARTNER_HOSTED_ONBOARDING::PAYMENT_SETUP_SUMMARY::CLOSE_DD_MODAL',
);

export const analyticsPartnerHostedOnboardingOpenPinwheelModal = createAction(
    'ANALYTICS::PARTNER_HOSTED_ONBOARDING::OPEN_PINWHEEL_MODAL',
);
export const analyticsPartnerHostedOnboardingStartApplication = createAction(
    'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::START_APPLICATION',
);

export const analyticsPartnerHostedOnboardingApplicationClickSubmitApplication =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLICK_SUBMIT_APPLICATION',
    );

export const analyticsPartnerHostedOnboardingApplicationOpenAutoTransferModal =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::OPEN_AUTO_TRANSFER_MODAL',
    );
export const analyticsPartnerHostedOnboardingApplicationViewEmployerInfoModal =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::VIEW_EMPLOYER_INFO_MODAL',
    );
export const analyticsPartnerHostedOnboardingApplicationViewValueProp =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::VIEW_VALUE_PROP',
    );
export const analyticsPartnerHostedOnboardingApplicationCloseAutoTransferModal =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLOSE_AUTO_TRANSFER_MODAL',
    );
export const analyticsPartnerHostedOnboardingApplicationClickTransfersAgreement =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLICK_TRANSFERS_AGREEMENT',
    );
export const analyticsPartnerHostedOnboardingApplicationClickAgreement =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLICK_AGREEMENT',
    );
export const analyticsPartnerHostedOnboardingApplicationClickRewards =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLICK_REWARDS',
    );
export const analyticsPartnerHostedOnboardingApplicationClickDirectDeposit =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLICK_DIRECT_DEPOSIT',
    );
export const analyticsPartnerHostedOnboardingApplicationClickConsent =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLICK_CONSENT',
    );
export const analyticsPartnerHostedOnboardingApplicationClickPrivacyPolicy =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLICK_PRIVACY_POLICY',
    );
export const analyticsPartnerHostedOnboardingApplicationClickPrivacyNotice =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLICK_PRIVACY_NOTICE',
    );
export const analyticsPartnerHostedOnboardingApplicationClickPatriot =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::CLICK_PATRIOT',
    );
export const analyticsPartnerHostedOnboardingApplicationToggleAutoApply =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::TOGGLE_AUTO_APPLY',
    );
export const analyticsPartnerHostedOnboardingApplicationToggleCreditReportingAgreement =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::TOGGLE_CREDIT_REPORTING_AGREEMENT',
    );
export const analyticsPartnerHostedOnboardingApplicationToggleCardHolderAgreement =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::TOGGLE_CARD_HOLDER_AGREEMENT',
    );
/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<boolean>} */
export const analyticsPartnerHostedOnboardingApplicationToggleReceiveText =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::TOGGLE_RECEIVE_TEXT',
    );
export const analyticsPartnerHostedOnboardingApplicationToggleAcceptAll =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::APPLICATION::TOGGLE_ACCEPT_ALL',
    );
export const analyticsPartnerHostedOnboardingUnsupportedEmployer = createAction(
    'ANALYTICS::PARTNER_HOSTED_ONBOARDING::UNSUPPORTED_EMPLOYERT',
);
export const analyticsPartnerHostedOnboardingClickDasboard = createAction(
    'ANALYTICS::PARTNER_HOSTED_ONBOARDING::CLICK_DASHBAORD',
);
export const analyticsNonCKPartnerHostedOnboardingRejectionScreen =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::NON_CK_REJECTION_SCREEN',
    );

/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<{partner: string, path: string, entryPoint: string}>} */
export const analyticsPartnerHostedOnboardingVerificationModalPasswordSubmitClicked =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::VERIFICATION_MODAL::PASSWORD_SUBMIT_CLICKED',
    );
/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<{partner: string, path: string, entryPoint: string}>} */
export const analyticsPartnerHostedOnboardingVerificationModalPasswordViewed =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::VERIFICATION_MODAL::PASSWORD_VIEWED',
    );

/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<{partner: string, path: string}>} */
export const analyticsPartnerHostedOnboardingVerificationModalVerifyPhoneViewed =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::VERIFICATION_MODAL::VERIFY_PHONE_VIEWED',
    );

export const analyticsPartnerHostedOnboardingVerificationModalVerifyPhoneClicked =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::VERIFICATION_MODAL::VERIFY_PHONE_CLICKED',
    );

/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<{partner: string}>} */
export const analyticsPartnerHostedOnboardingVerificationModalHelpViewed =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::VERIFICATION_MODAL::HELP_VIEWED',
    );

/** @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<{partner: string}>} */
export const analyticsPartnerHostedOnboardingVerificationModalUpdatePhoneViewed =
    createAction(
        'ANALYTICS::PARTNER_HOSTED_ONBOARDING::VERIFICATION_MODAL::UPDATE_PHONE_VIEWED',
    );
